var Vendor = {
  jQuery: window.jQuery,
};

// Only allow access via Vendor / module import
delete window.jQuery;
